import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'
import {ISurveyPayload} from '../../SERVICE-INTERFACES'

const survey_endpoints = APIS_ENDPOINTS.survey

export const request_create = async ({Question, Option1, Option2, Option3, Option4, Option5, SurveyCategoryId}: ISurveyPayload) => {
  const formData = new FormData()
  formData.append('Question', Question)
  formData.append('Option1', Option1)
  formData.append('Option2', Option2) 
  formData.append('Option3', Option3)
  formData.append('Option4', Option4)
  formData.append('Option5', Option5)
  formData.append('SurveyCategoryId', SurveyCategoryId.toString())

  return http.post(survey_endpoints.create, formData)
}
export const request_edit = async ({Question, Option1, Option2, Option3, Option4, Option5, SurveyCategoryId, Id}: ISurveyPayload) => {
  const formData = new FormData()
  formData.append('Question', Question)
  formData.append('Option1', Option1)
  formData.append('Option2', Option2)
  formData.append('Option3', Option3)
  formData.append('Option4', Option4)
  formData.append('Option5', Option5)
  formData.append('SurveyCategoryId', SurveyCategoryId.toString())
  formData.append('Id', Id?.toString() || '')

  return http.put(survey_endpoints.edit, formData)
}

export const request_getAll = async ({
  search,
  CurrentPage,
  PageSize,
  SurveyCategory
}: {
  search?: string
  CurrentPage: number
  PageSize: number
  SurveyCategory: number
}) => {
  return http.get(
    survey_endpoints.getlist +
      `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}${SurveyCategory ? `&SurveyCategory=${SurveyCategory}` : ''}`
  )
}

export const request_delete = async (id: number) => {
  return http.delete(survey_endpoints.delete + `?Id=${id}`)
}

export const request_unactive = async (id: number) => {
  return http.delete(survey_endpoints.unactive + `?Id=${id}`)
}

export const request_active = async (id: number) => {
  return http.put(survey_endpoints.active + `?Id=${id}`)
}
